<template>
  <div class="admin-settings-page">
    <div class="skip-links">
      <a href="#main-content" class="skip-link">Zum Hauptinhalt</a>
    </div>

    <div class="container-fluid p-4" id="main-content">
      <!-- Breadcrumb Navigation -->
      <nav aria-label="breadcrumb" class="mb-4">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/admin">
              <font-awesome-icon icon="cog" class="me-1" />
              Admin
            </router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            <font-awesome-icon icon="cogs" class="me-1" />
            System-Einstellungen
          </li>
        </ol>
      </nav>

      <!-- Page Header -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h1 class="mb-0">
          <font-awesome-icon icon="cogs" class="me-2" />
          System-Einstellungen
        </h1>
        <BackButton fallback="admin" />
      </div>

      <!-- System Settings -->
      <div class="card shadow-sm">
        <div class="card-body">
          <p class="text-muted mb-4">
            Hier können zukünftige Systemeinstellungen verwaltet werden.
          </p>
          
          <div class="alert alert-info">
            <font-awesome-icon icon="info-circle" class="me-2" />
            Weitere Einstellungen werden in zukünftigen Updates hinzugefügt.
          </div>

          <!-- Placeholder for future settings -->
          <div class="row g-4 mt-3">
            <div class="col-md-6">
              <div class="settings-card">
                <div class="settings-card-icon">
                  <font-awesome-icon icon="database" />
                </div>
                <div class="settings-card-content">
                  <h5>Datenbank-Einstellungen</h5>
                  <p class="text-muted small">Verwalte Datenbankverbindungen und -konfigurationen</p>
                  <button class="btn btn-sm btn-outline-secondary" disabled>
                    <font-awesome-icon icon="lock" class="me-1" />
                    Bald verfügbar
                  </button>
                </div>
              </div>
            </div>
            
            <div class="col-md-6">
              <div class="settings-card">
                <div class="settings-card-icon">
                  <font-awesome-icon icon="envelope" />
                </div>
                <div class="settings-card-content">
                  <h5>E-Mail-Einstellungen</h5>
                  <p class="text-muted small">Konfiguriere SMTP-Server und E-Mail-Templates</p>
                  <button class="btn btn-sm btn-outline-secondary" disabled>
                    <font-awesome-icon icon="lock" class="me-1" />
                    Bald verfügbar
                  </button>
                </div>
              </div>
            </div>
            
            <div class="col-md-6">
              <div class="settings-card">
                <div class="settings-card-icon">
                  <font-awesome-icon icon="shield-alt" />
                </div>
                <div class="settings-card-content">
                  <h5>Sicherheitseinstellungen</h5>
                  <p class="text-muted small">Verwalte Authentifizierung und Zugriffsrechte</p>
                  <button class="btn btn-sm btn-outline-secondary" disabled>
                    <font-awesome-icon icon="lock" class="me-1" />
                    Bald verfügbar
                  </button>
                </div>
              </div>
            </div>
            
            <div class="col-md-6">
              <div class="settings-card">
                <div class="settings-card-icon">
                  <font-awesome-icon icon="chart-bar" />
                </div>
                <div class="settings-card-content">
                  <h5>Analyse & Berichte</h5>
                  <p class="text-muted small">Konfiguriere Berichte und Analysefunktionen</p>
                  <button class="btn btn-sm btn-outline-secondary" disabled>
                    <font-awesome-icon icon="lock" class="me-1" />
                    Bald verfügbar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>
